import { render, staticRenderFns } from "./AccRmaReviews.vue?vue&type=template&id=74eee128&scoped=true&"
import script from "./AccRmaReviews.vue?vue&type=script&lang=js&"
export * from "./AccRmaReviews.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74eee128",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src2141801166/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('74eee128')) {
      api.createRecord('74eee128', component.options)
    } else {
      api.reload('74eee128', component.options)
    }
    module.hot.accept("./AccRmaReviews.vue?vue&type=template&id=74eee128&scoped=true&", function () {
      api.rerender('74eee128', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/containers/Customer/Devices/Accessories/AccRmaReviews.vue"
export default component.exports